<dx-form [formData]="flightPreference" [labelLocation]="'top'" labelMode="floating">
  <dxi-item itemType="group" [colCount]="3">
    <div *dxTemplate>
      <dx-data-grid
        *var="inEditMode$ | async as inEditMode"
        [ngClass]="{ 'ag-profile-grid__grid': LayoutGridType.default !== type }"
        [dataSource]="flightPreference.airlinePreferences"
        [showRowLines]="LayoutGridType.default === type"
        [showBorders]="LayoutGridType.default === type"
        [showColumnLines]="LayoutGridType.short !== type"
        [showColumnHeaders]="LayoutGridType.short !== type"
        [columnAutoWidth]="LayoutGridType.default !== type"
        [wordWrapEnabled]="inEditMode"
        [filterRow]="{ visible: LayoutGridType.default === type }"
        (onSaved)="onRowSaved()"
        (onRowValidating)="onRowValidating($event)"
        height="100%"
      >
        <dxo-toolbar>
          <dxi-item location="before">
            <div *dxTemplate>
              <div class="toolbar-label dx-form-group-caption">
                Preferred Airlines
              </div>
            </div>
          </dxi-item>

          @if (hasPermissionsToEdit) {
            <dxi-item
              [visible]="!inEditMode"
              location="after"
              widget="dxButton"
              locateInMenu="auto"
              [cssClass]="'ag-profile-grid__toolbar-button'"
              [options]="{ hint: 'ENABLE EDIT', icon: 'edit', stylingMode: 'text', onClick: enableEditMode }"
            ></dxi-item>

            <dxi-item
              [visible]="inEditMode"
              location="after"
              widget="dxButton"
              locateInMenu="auto"
              [cssClass]="'ag-profile-grid__toolbar-button'"
              [options]="{
            hint: 'CANCEL EDIT',
            icon: 'undo',
            type: 'danger',
            stylingMode: 'text',
            onClick: disableEditMode,
          }"
            ></dxi-item>
          }

          @if (inEditMode && hasPermissionsToAdd) {
            <dxi-item
              location="after"
              widget="dxButton"
              [cssClass]="type !== LayoutGridType.default ? 'ag-profile-grid__toolbar-button' : ''"
              [options]="{
            icon: 'plus',
            onClick: showAddPreferredAirlinePopup,
            stylingMode: type !== LayoutGridType.default ? 'text' : 'outlined',
          }"
            ></dxi-item>
          }
        </dxo-toolbar>

        <dxo-editing
          mode="row"
          [useIcons]="true"
          [allowUpdating]="false"
          [allowDeleting]="hasPermissionsToDelete"
          [allowAdding]="false">
        </dxo-editing>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>

        <!-- Columns -->
        <dxi-column
          [name]="'fullAssociations'"
          [caption]="''"
          cellTemplate="fullPreferredAirlineCellTemplate"
          [sortIndex]="0"
          [sortOrder]="'asc'"
          [visible]="type === LayoutGridType.short"
        >
          <div *dxTemplate="let cell of 'fullPreferredAirlineCellTemplate'">
            <p *var="cell?.data?.airline | lookupDescriptionText: AIRLINES_LOOKUP as airline">
              @switch (airline) {
                @case (Airlines.Other) {
                  {{ cell?.data?.otherPreferredAirline }}
                  <sup class="flight-preference-form__superscript">other</sup>
                }
                @default {
                  {{ airline }}
                  <sup class="flight-preference-form__superscript" *ngIf="cell?.data?.isFirstChoiceAirline">1st</sup>
                  <sup class="flight-preference-form__superscript" *ngIf="cell?.data?.isSecondChoiceAirline">2nd</sup>
                }
              }
              <span *ngIf="cell?.data?.loyaltyNumber as loyaltyNumber"> &mdash; {{ loyaltyNumber }}</span>
            </p>
          </div>
        </dxi-column>

        <dxi-column
          dataField="airline"
          caption="Preferred Airline"
          editCellTemplate="airlineEditorCellTemplate"
          [sortIndex]="0"
          [sortOrder]="'asc'"
          [visible]="type !== LayoutGridType.short"
        >
          <dxo-lookup [dataSource]="AIRLINES_LOOKUP" displayExpr="description" valueExpr="value"></dxo-lookup>
        </dxi-column>

        <dxi-column
          dataField="otherPreferredAirline"
          caption="Other Airline"
          dataType="string"
          [minWidth]="160"
          [visible]="LayoutGridType.short !== type"
        ></dxi-column>

        <dxi-column
          dataField="loyaltyNumber"
          caption="Loyalty Number"
          [validationRules]="[{ type: 'stringLength', max: 20 }]"
          [visible]="type !== LayoutGridType.short"
        ></dxi-column>

        <dxi-column
          dataField="isFirstChoiceAirline"
          caption="1st Choice"
          [dataType]="'boolean'"
          [width]="110"
          [visible]="type !== LayoutGridType.short"
        ></dxi-column>

        <dxi-column
          dataField="isSecondChoiceAirline"
          caption="2nd Choice"
          [dataType]="'boolean'"
          [width]="110"
          [visible]="type !== LayoutGridType.short"
        ></dxi-column>

        <dxi-column
          type="buttons"
          [visible]="inEditMode"
          [width]="LayoutGridType.default !== type ? '60px' : undefined">
          <dxi-button
            icon="edit"
            [cssClass]="'ag-profile-grid__col-button'"
            [visible]="hasPermissionsToEdit"
            [onClick]="showEditPopup"
          ></dxi-button>
          <dxi-button
            name="delete"
            icon="trash"
            [cssClass]="'ag-profile-grid__col-button'"
            [visible]="hasPermissionsToDelete"
          ></dxi-button>
        </dxi-column>
      </dx-data-grid>
    </div>
  </dxi-item>

  <!-- Group: Other -->
  <dxi-item itemType="group" caption="Other" [colCount]="3">
    <dxi-item [dataField]="FlightInfoKeys.knownTravelerNumber" editorType="dxTextBox">
      <dxo-label text="Known Traveler #"></dxo-label>
    </dxi-item>

    <dxi-item
      [dataField]="FlightInfoKeys.seatPreference"
      editorType="dxSelectBox"
      [editorOptions]="{
        items: SEAT_PREFERENCE_LOOKUP,
        displayExpr: LookupKeys.description,
        valueExpr: LookupKeys.value,
      }"
    >
      <dxo-label text="Seat Preference"></dxo-label>
    </dxi-item>

    <dxi-item [dataField]="FlightInfoKeys.preferredDepartureAirport" editorType="dxTextBox">
      <dxo-label text="Preferred Departure Airport"></dxo-label>
    </dxi-item>
  </dxi-item>
</dx-form>

<ag-shr-modal-window
  #preferredAirlineModalRef
  [title]="airlinePreferenceModalTitle"
  [inProgress]="inProgress$ | async"
  [width]="'450px'"
  [height]="'auto'"
  [onCloseModal]="handlePreferredAirlineFormPopupClose"
  (onSaveClick)="handlePreferredAirlineSave($event)"
>
  <ng-container *ngIf="preferredAirlineModalRef?.popupComponent?.visible ?? false">
    <ag-edit-flight-preference-form
      #airlinePreferenceFormRef
      [airlinePreference]="airlinePreferenceToEdit"
      [validationGroup]="validationGroup"
      [filteredAirlines]="filteredAirlines$ | async"
      [isFirstChoiceDisabled]="airlinePreferenceToEdit | isFirstChoiceSelected : flightPreference.airlinePreferences"
      [isSecondChoiceDisabled]="airlinePreferenceToEdit | isSecondChoiceSelected : flightPreference.airlinePreferences"
      (updateFilteredAirlines)="updateFilteredAirlines()"
    ></ag-edit-flight-preference-form>
  </ng-container>
</ag-shr-modal-window>
